export default __webpack_public_path__ + "static/media/bj.8d6fbc83.svg";